var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('br'),_c('br'),_c('br'),_c('Hero'),(false)?_c('Smart'):_vm._e(),_c('Simple'),_c('Secure'),(false)?_c('Solutions'):_vm._e(),(false)?_c('Calltoaction'):_vm._e(),_c('VideoModal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }